import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ContentTypeCard } from 'components/molecules'
import { FEATURED } from 'constants/appConstants'

const RenderGenericCards = ({ item, contentType, itemHeight, featured, handleStatus }) => {
  return (
    <Link to={`/${contentType !== FEATURED ? contentType : item.contentType}/${item?.documentId || item?.documentId}`}>
      <ContentTypeCard
        item={item}
        itemHeight={itemHeight}
        contentType={contentType !== FEATURED ? contentType : item.contentType}
        featured={featured}
        handleStatus={handleStatus}
      />
    </Link>
  )
}

RenderGenericCards.defaultProps = {
  contentType: '',
  itemHeight: '',
  featured: 'false',
  handleStatus: () => {},
}

RenderGenericCards.propTypes = {
  item: PropTypes.object.isRequired,
  contentType: PropTypes.string,
  itemHeight: PropTypes.string,
  featured: PropTypes.bool,
  handleStatus: PropTypes.func,
}

export default RenderGenericCards
